import { BaseProjectData, ProjectCategory } from '@canvas/canvas-lib';
import { PaymentProviderType } from '../../../common/dtos/payment-provider-type';
import { IProject, ProjectFromApi } from '../../projects/dtos/project';
import { AssetStatus } from '../../assets/dtos/asset-status';

export enum EntityType {
  All = 0,
  SupplyPartner = 100,
  ServiceProvider = 200,
  Buyer = 300,
  Participant = 400,
  Community = 500,
  Financier = 600,
  FinancingGroup = 700,
}

export function getEntityTypeText(entityType: EntityType): string {
  switch (entityType) {
    case EntityType.ServiceProvider:
      return 'Service Provider';
    case EntityType.SupplyPartner:
      return 'Supply Partner';
    default:
      return EntityType[entityType];
  }
}

export interface ILookupEntity {
  id: number;
  name: string;
}

export interface IGenericLookupEntity<T> {
  id: number;
  name: string;
  value: T;
}

export interface IEntity extends ILookupEntity {
  entityType: EntityType;
  customerID: string;
  uniqueIdentifier: string;
  location: string;
  metadata?: IEntityMetaData;
  metadataJson?: string;
  paymentData: IPaymentData;
  personalInformation?: IPersonalInformation;
}
export interface IPersonalInformation {
  firstName: string;
  lastName: string;
  city: string;
  country: string;
  postCode: string;
  state: string;
  streetAddress: string;
}
export interface IEntityMetaData {
  contactName: string;
  contactNumber: string;
  emailAddress: string;
  businessLicence: string;
  typeOfBusiness: string;
  businessInterests: string;
  dateEstablished?: string;
  dateOfBirth?: string;
  gender?: number;
  communityOwnerName?: string;
  communityMembers?: Array<string>;
  userGroup?: number;
  projectId?: number;
  assignedProjects?: number[];
}

export interface IPaymentData {
  currency: string;
  paymentProvider?: PaymentProviderType;
  accountNumber?: string;
  accountValidationStatus: AccountNumberValidationStatus;
  bankCode?: string;
  bankReference?: string;
  providerDataJson?: string;
}

export enum AccountNumberValidationStatus {
  Unverified = 0,
  Verified = 1,
  Invalid = 2,
}

export interface IPaymentAccountInformation {
  accountNumber: string;
  bankCode: string;
  bankReference: string;
}

export interface IThunesDetails {
  id: number;
  name: string;
  type: ThunesPayerType;
}

export type EntityWithProjects = IEntity & {
  projects: IProject[];
  linkedProject?: BaseProjectData;
  assets?: IAssetInfo[];
};

export interface IAssetInfo {
  id: number;
  assetId: string;
  status: AssetStatus;
}

export type EntityWithProjectsFromApi = Omit<EntityWithProjects, 'projects'> & {
  projects: ProjectFromApi[];
};

export interface ThunesPayerList {
  id: number;
  name: string;
  currency: string;
  countryIso: string;
  type: number;
  service: ThunesPayerType;
}

export enum ThunesPayerType {
  BankAccount = 1,
  MobileWallet = 2,
}

export interface ThunesPayerPayload {
  id: number;
  type: number;
  name: string;
  countryIsoCode: string;
  currency: string;
}

export interface PawaPayPayload {
  operator_name: string;
}
